module.exports = __webpack_public_path__ + "static/media/inter-light.5baca21a.woff2";